import * as React from 'react';

function SvgInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M6 12.98C8.75038 12.98 10.98 10.7504 10.98 8C10.98 5.24962 8.75038 3.02 6 3.02C3.24962 3.02 1.02 5.24962 1.02 8C1.02 10.7504 3.24962 12.98 6 12.98ZM6 14C9.31371 14 12 11.3137 12 8C12 4.68629 9.31371 2 6 2C2.68629 2 0 4.68629 0 8C0 11.3137 2.68629 14 6 14Z" fill="#5B6578"/>
      <path d="M6.66341 10.6663C6.66341 11.0345 6.36493 11.333 5.99674 11.333C5.62856 11.333 5.33008 11.0345 5.33008 10.6663V7.99967C5.33008 7.63148 5.62856 7.33301 5.99674 7.33301C6.36493 7.33301 6.66341 7.63148 6.66341 7.99967V10.6663Z" fill="#5B6578"/>
      <path d="M6.66341 5.33268C6.66341 5.70087 6.36493 5.99935 5.99674 5.99935C5.62856 5.99935 5.33008 5.70087 5.33008 5.33268C5.33008 4.96449 5.62856 4.66602 5.99674 4.66602C6.36493 4.66602 6.66341 4.96449 6.66341 5.33268Z" fill="#5B6578"/>
    </svg>
  );
}

export default SvgInfo;
